import { type NavigationProps } from '@react-native-common/common'

type NavigationData = NavigationProps['data']

export const BASE_B2C_NAVIGATION_MODEL: NavigationData = {
  logo: {
    href: '/',
  },
  profile: {
    label: 'Navigation.User',
    avatarUrl: '',
    username: '',
    email: '',
    language: '',
    country: '',
    countryName: '',
    currency: '',
    regionalSettingsHref: '/settings/more',
  },
  items: [
    {
      type: 'Search',
      label: 'General.NavigationTab.Search',
      href: '/',
      icon: 'searchThin',
      display: ['desktop', 'mobile'],
    },
    {
      type: 'Favorites',
      label: 'General.NavigationTab.Favorites',
      href: '/favorites',
      icon: 'favoriteThin',
      display: ['desktop', 'mobile'],
    },
    {
      type: 'Chat',
      label: 'Navigation.Messages',
      href: '/messages/',
      icon: 'chat',
      display: ['desktop', 'mobile'],
    },
    {
      type: 'Estimate',
      label: 'General.NavigationTab.Estimate',
      href: '/my-properties',
      icon: 'estimate',
      display: ['desktop', 'mobile'],
    },
    {
      type: 'PostAd',
      label: 'General.NavigationTab.PostAd',
      href: '/let-your-home',
      icon: 'postAd',
      display: ['desktop', 'mobile'],
    },
    {
      type: 'MyProfile',
      label: 'Navigation.MyProfile',
      display: ['desktop', 'mobile'],
      href: '/my-profile/',
      mobile: {
        href: '/settings/profile',
        order: 6,
      },
      submenu: [
        {
          type: 'MyProfile',
          label: 'Navigation.MyProfile.MyProfile',
          href: '/my-profile/',
          icon: 'profileDropdown',
          group: 'primary',
        },
        {
          type: 'RegionalSettings',
          label: 'Navigation.MyProfile.RegionalSettings',
          href: '/my-profile/settings',
          icon: 'planet',
          group: 'primary',
        },
        {
          type: 'Security',
          label: 'Navigation.MyProfile.Security',
          href: '/my-profile/security',
          icon: 'lock',
          group: 'primary',
        },
        {
          type: 'GetMobileApp',
          label: 'Navigation.MyProfile.GetMobileApp',
          icon: 'smartphone',
          group: 'secondary',
        },
        {
          type: 'SwitchToDashboard',
          label: 'Settings.Profile.Dropdown.SwitchToDashboard',
          icon: 'refresh',
          group: 'secondary',
        },
        {
          type: 'Professionals',
          label: 'Settings.Profile.Dropdown.AgentDashboard',
          icon: 'agentDashboardThin',
          group: 'secondary',
        },
        {
          type: 'Logout',
          label: 'Navigation.MyProfile.Logout',
          icon: 'disconnect',
          group: 'logout',
        },
      ],
    },
  ],
}
